import React, { useEffect, useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name:'', contact_person:'', contact_email:'', phone:'', address:'' });

  const load = () => { setLoading(true); api.get('/clients').then(r => setClients(r.data.clients)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const openAdd = () => { setEditing(null); setForm({ name:'', contact_person:'', contact_email:'', phone:'', address:'' }); setShowModal(true); };
  const openEdit = (c) => { setEditing(c); setForm({ name:c.name, contact_person:c.contact_person||'', contact_email:c.contact_email||'', phone:c.phone||'', address:c.address||'' }); setShowModal(true); };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await api.put(`/clients/${editing.id}`, form); toast.success('Client updated.'); }
      else         { await api.post('/clients', form);              toast.success('Client created.'); }
      setShowModal(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed.'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Clients</h1><p className="page-sub">{clients.length} total</p></div>
        <button className="btn btn-primary" onClick={openAdd}>+ New Client</button>
      </div>

      {loading ? <div className="loading">Loading…</div> : clients.length === 0 ? (
        <div className="card"><div className="empty"><div className="empty-icon">🏢</div><p>No clients yet.</p></div></div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:14}}>
          {clients.map(c => (
            <div key={c.id} className="card">
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                <div style={{fontWeight:600,fontSize:15}}>{c.name}</div>
                <button className="btn btn-secondary btn-sm" onClick={() => openEdit(c)}>Edit</button>
              </div>
              {c.contact_person && <div className="text-sm text-muted" style={{marginBottom:4}}>👤 {c.contact_person}</div>}
              {c.contact_email  && <div className="text-sm text-muted" style={{marginBottom:4}}>✉️ {c.contact_email}</div>}
              {c.phone          && <div className="text-sm text-muted" style={{marginBottom:4}}>📞 {c.phone}</div>}
              {c.address        && <div className="text-sm text-muted">📍 {c.address}</div>}
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e=>e.stopPropagation()}>
            <div className="modal-title">{editing ? 'Edit Client' : 'New Client'}</div>
            <form onSubmit={handleSave} className="form-grid">
              <div className="field"><label>Company Name *</label><input required value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Acme Corporation"/></div>
              <div className="form-row">
                <div className="field"><label>Contact Person</label><input value={form.contact_person} onChange={e=>setForm({...form,contact_person:e.target.value})} placeholder="John Smith"/></div>
                <div className="field"><label>Contact Email</label><input type="email" value={form.contact_email} onChange={e=>setForm({...form,contact_email:e.target.value})} placeholder="john@acme.com"/></div>
              </div>
              <div className="field"><label>Phone</label><input value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="+91 98765 43210"/></div>
              <div className="field"><label>Address</label><textarea rows={2} value={form.address} onChange={e=>setForm({...form,address:e.target.value})} placeholder="123 Business Park, Mumbai"/></div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowModal(false)}>Cancel</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving?'Saving…':editing?'Update':'Create Client'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
